export default "__VITE_ASSET__d83ab9cc__"